<template>
  <div class="top-header" :class="{highlight: inCall}">
    <div class="logo">
      <i class="iconfont iconicon-mzsq"></i>
      <p>{{Config.SYSTEM_TITLE}}</p>
      <p>{{Config.SYSTEM_SUB_TITLE}}</p>
    </div>
    <div class="center-content"></div>
    <div class="right-blocks">
      <div
        class="block dashboard"
        :class="{selected: $route.path === '/dashboard'}"
        @click="routeTo('/dashboard')"
      >我的工作台</div>
      <div class="block">设备检测</div>
      <div class="block state">
        <i class="iconfont iconyunxiazai"></i>
        <i class="iconfont iconwifi"></i>
      </div>
      <el-dropdown placement="bottom">
        <div class="block drop-down">
          {{$store.state.initialInfo.displayName}} - {{$store.state.initialInfo.extension}}
          <i
            class="iconfont icondown"
          ></i>
        </div>
        <el-dropdown-menu slot="dropdown" class="top-header-menu">
          <el-dropdown-item @click.native="logout">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="block">台席</div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    inCall() {
      // 振铃、拨号、通话中
      return this.$store.state.callState >= 6 && this.$store.state.callState <= 12
    }
  },
  methods: {
    logout() {
      this.$confirm('确定退出系统吗？').then(() => {
        this.$store.commit('logout')
        this.routeTo('/login')
      })
    }
  }
}
</script>
